/**
 * Bind reCAPTCHA form submission to all forms with `data-recaptcha="true"`.
 *
 * Intercepts the form submit event, fetches a fresh reCAPTCHA v3 token via
 * `grecaptcha.execute()`, sets it on the hidden `.g-recaptcha` input, and
 * then submits the form programmatically.
 *
 * This ensures the token is always fresh — reCAPTCHA v3 tokens expire after ~2 minutes,
 * so fetching on page load (as was done before) caused stale tokens on slow form fills.
 *
 * Requirements in the Blade template:
 * - `<form>` must have `data-recaptcha="true"`
 * - `<form>` must contain `<input type="hidden" class="g-recaptcha" name="g-recaptcha-response">`
 * - The global `config.settings.recaptcha_site_key` JS variable must be set
 * - The Google reCAPTCHA v3 script must be loaded (`api.js?render=<site_key>`)
 */
export const bindRecaptchaFormSubmission = function () {
    const recaptchaSiteKey = config.settings.recaptcha_site_key;

    if (!recaptchaSiteKey || !recaptchaSiteKey.length) {
        return;
    }

    if (typeof grecaptcha === 'undefined') {
        return;
    }

    const forms = document.querySelectorAll('form[data-recaptcha="true"]');

    forms.forEach((form) => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const hiddenInput = form.querySelector('.g-recaptcha');

            if (!hiddenInput) {
                form.submit();
                return;
            }

            grecaptcha.ready(() => {
                grecaptcha.execute(recaptchaSiteKey, {
                    action: 'validate_captcha'
                }).then((token) => {
                    hiddenInput.value = token;
                    form.submit();
                });
            });
        });
    });
};

